import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const FilterIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 14, height = 14, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.33331 2.33333H11.6666V3.60033C11.6666 3.90972 11.5436 4.20642 11.3248 4.42516L8.74998 7V11.0833L5.24998 12.25V7.29166L2.63665 4.417C2.44149 4.20229 2.33334 3.92256 2.33331 3.63241V2.33333Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
